var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.146 3.646a.5.5 0 01.708 0l8 8a.5.5 0 010 .708l-8 8a.5.5 0 01-.708-.708L15.793 12 8.146 4.354a.5.5 0 010-.708z",
    fill: "#4D008C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC4xNDY0NSAzLjY0NjQ1QzguMzQxNzEgMy40NTExOCA4LjY1ODI5IDMuNDUxMTggOC44NTM1NSAzLjY0NjQ1TDE2Ljg1MzYgMTEuNjQ2NEMxNy4wNDg4IDExLjg0MTcgMTcuMDQ4OCAxMi4xNTgzIDE2Ljg1MzYgMTIuMzUzNkw4Ljg1MzU1IDIwLjM1MzZDOC42NTgyOSAyMC41NDg4IDguMzQxNzEgMjAuNTQ4OCA4LjE0NjQ1IDIwLjM1MzZDNy45NTExOCAyMC4xNTgzIDcuOTUxMTggMTkuODQxNyA4LjE0NjQ1IDE5LjY0NjRMMTUuNzkyOSAxMkw4LjE0NjQ1IDQuMzUzNTVDNy45NTExOCA0LjE1ODI5IDcuOTUxMTggMy44NDE3MSA4LjE0NjQ1IDMuNjQ2NDVaIiBmaWxsPSIjNEQwMDhDIi8+Cjwvc3ZnPgo=";
export { SvgChevron as ReactComponent };